export * from './entry-component-loading-module.js';
export * from './ReactEntryComponentInjector.js';
//# sourceMappingURL=index.js.map